webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(207);
	module.exports = __webpack_require__(144);


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _endpointsAjaxHandlers = __webpack_require__(15);
	
	var _commonNotifier = __webpack_require__(148);
	
	var _commonNotifier2 = _interopRequireDefault(_commonNotifier);
	
	var _commonUtils = __webpack_require__(3);
	
	var _endpointsAccountSettingsService = __webpack_require__(14);
	
	var _endpointsAccountSettingsService2 = _interopRequireDefault(_endpointsAccountSettingsService);
	
	var _endpointsUrls = __webpack_require__(9);
	
	var _endpointsUrls2 = _interopRequireDefault(_endpointsUrls);
	
	var _commonValidators = __webpack_require__(13);
	
	__webpack_require__(145);
	
	// importing in a single place to initiate the monitor
	
	__webpack_require__(32);
	
	/**
	 * Initializes jquery validator with default configurations
	 */
	function initializeValidators() {
	
	    _jquery2['default'].extend(_jquery2['default'].validator.messages, {
	        required: "Required"
	    });
	
	    _jquery2['default'].validator.setDefaults({
	        //2023_02_06: Updated the "ignore" option to validate selectize input elements.
	        //ignore : ':hidden:not(.validate)',
	        /**
	         * See https://gist.github.com/yannleretaille/8498983 to set up validator selectors when using selectize.js
	         *
	         * the default ignore selector is ':hidden', the following selectors restore the default behaviour when using selectize.js
	         *
	         * :hidden:not([class~=selectized]) | selects all hidden elements, but not the original selects/inputs hidden by selectize
	         * :hidden > .selectized | to restore the behaviour of the default selector, the original selects/inputs are only validated if their parent is visible
	         * .selectize-control .selectize-input input | this rule is not really necessary, but ensures that the temporary inputs created by selectize on the fly are never validated
	         *
	         **/
	        ignore: ':hidden:not(.validate,[class~=selectized]), :hidden > .selectized, .selectize-control .selectize-input input',
	        highlight: function highlight(e) {
	            (0, _jquery2['default'])(e).closest('.form-group').addClass('has-error');
	        },
	        unhighlight: function unhighlight(e) {
	            (0, _jquery2['default'])(e).closest('.form-group').removeClass('has-error');
	        },
	        errorPlacement: function errorPlacement(error, element) {
	            var insertAfter = element;
	
	            if (element.is(':radio') || element.is(':checkbox') || element.is('select')) {
	                insertAfter = (0, _jquery2['default'])(element).closest('div');
	            }
	
	            var formGroup = element.closest('.form-group');
	            if (formGroup.length === 1 && formGroup.is('.condensed') && formGroup.find('.help-block').length > 0) {
	
	                formGroup.find('.help-block').prepend(error);
	                return;
	            }
	
	            error.insertAfter(insertAfter);
	        },
	        focusInvalid: false,
	        invalidHandler: function invalidHandler(form, validator) {
	
	            if (!validator.numberOfInvalids()) return;
	
	            var el = (0, _jquery2['default'])(validator.errorList[0].element);
	            var parent = el.closest('.content-section, .content-wrap');
	            var scrolltop = el.offset() && parent.offset() ? el.offset().top - parent.offset().top - 10 : 0;
	
	            (0, _jquery2['default'])('html, body').animate({
	                scrollTop: scrolltop
	            }, { duration: 500,
	                complete: function complete() {
	                    el.trigger('focus');
	                }
	            });
	        }
	    });
	
	    //override default date validator to make all date as MM/DD/YYYY
	    _jquery2['default'].validator.methods.date = _commonUtils.isValidDate;
	    _jquery2['default'].validator.messages['date'] = 'Enter date as MM/DD/YYYY';
	
	    //TODO: refactor validators to specific pages where they are used
	    _commonValidators.amount.addMethod();
	    _commonValidators.phoneNCAA.addMethod();
	    _commonValidators.dateInPast.addMethod();
	    _commonValidators.dateInFuture.addMethod();
	    _commonValidators.dateAfterStart.addMethod();
	    _commonValidators.uniqueUserName.addMethod();
	    _commonValidators.passwordNCAA.addMethod();
	}
	
	/**
	 * Initialize all global exception handlers
	 */
	function wireUpExceptionHandlers() {
	
	    (0, _endpointsAjaxHandlers.addAjaxErrorListener)(function (error) {
	        if (error.data.status === 401 && !error.isJSON) {
	            var returnUrl = window.location.pathname.replace(_endpointsUrls2['default'].getContextRoot(), '/');
	            window.location = _endpointsUrls2['default'].getContextRoot() + ('/login?returnUrl=/' + returnUrl);
	        } else {
	            _commonNotifier2['default'].error(error.message, "Ajax Error");
	        }
	    });
	}
	
	function wireUpMobileLayout() {
	    // Subnav mobile toggle
	    (0, _jquery2['default'])('.nav-toggle').on('click', function (e) {
	        (0, _jquery2['default'])(this).parent('.subnav').toggleClass('open');
	    });
	
	    // Secondary nav toggle
	    (0, _jquery2['default'])('#sidebar > .nav > li > .parent').on('click', function (e) {
	        var subnavID = (0, _jquery2['default'])(this).data('subnav');
	        if ((0, _jquery2['default'])('#sidebar > .nav > li > .parent').parent().css('display') == "inline-block") {
	            e.preventDefault();
	            (0, _jquery2['default'])('#' + subnavID + '.nav-sm').toggleClass('open');
	        }
	    });
	
	    // Content tabs mobile toggle
	    (0, _jquery2['default'])('.content-tabs .nav-tabs').on('click', function (e) {
	        if ((0, _jquery2['default'])(this).children('li').css('display') == "block") {
	            (0, _jquery2['default'])(this).parent().toggleClass('open');
	        }
	    });
	}
	
	function openTasksCount() {
	    var taskCountAlert = (0, _jquery2['default'])(".dropdown-menu #task-count");
	    if (taskCountAlert.length) {
	        _endpointsAccountSettingsService2['default'].openTasksCount().then(function (openTaskCount) {
	            if (openTaskCount) {
	                taskCountAlert.removeClass("hidden");
	                taskCountAlert.text(openTaskCount);
	                (0, _jquery2['default'])(".tasks .alert").removeClass("hidden");
	            }
	        })['catch'](function () {/* don't disrupt user if count unavailable */});
	    }
	}
	
	function wireUpHelpPanel() {
	    // Help panel toggle
	    (0, _jquery2['default'])('.utility-nav .help, #help-menu .close').on('click', function (e) {
	        e.preventDefault();
	        (0, _jquery2['default'])('#help-menu').toggleClass('open');
	    });
	    window.fn = window.fn || {};
	    window.fn.setFaq = function (hash) {
	        var currentFaqs = (0, _jquery2['default'])('#faq-' + hash.substr(1));
	        if (currentFaqs.length > 0) {
	            (0, _jquery2['default'])('#help-menu #faqs').html(currentFaqs.clone());
	        }
	    };
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	    wireUpExceptionHandlers();
	    initializeValidators();
	    wireUpMobileLayout();
	    openTasksCount();
	    wireUpHelpPanel();
	
	    //initialize all the custom animations for bootstrap-material-design
	    _jquery2['default'].material.init();
	});

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	window.dataLayer = window.dataLayer || [];
	
	function gtag() {
	    window.dataLayer.push(arguments);
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	    var rootEl = (0, _jquery2["default"])('#contextRoot');
	    var tagId = rootEl.data('analytics-code');
	    var gTagUrl = "https://www.googletagmanager.com/gtag/js?id=" + tagId;
	
	    _jquery2["default"].getScript(gTagUrl, function () {
	        gtag('js', new Date());
	        gtag('config', tagId);
	    });
	});

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _toastr = __webpack_require__(138);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	__webpack_require__(206);
	
	_toastr2['default'].options = {
	    "closeButton": true,
	    "positionClass": "toast-top-right",
	    "preventDuplicates": true,
	    "showDuration": "300",
	    "hideDuration": "1000",
	    "timeOut": "5000",
	    "extendedTimeOut": "1000",
	    "showEasing": "swing",
	    "hideEasing": "linear",
	    "showMethod": "fadeIn",
	    "hideMethod": "fadeOut"
	};
	
	function error(message, title) {
	    _toastr2['default']["error"](message, title || "Error");
	}
	
	function success(message, title) {
	    _toastr2['default']["info"](message, title || "Success");
	}
	
	exports['default'] = {
	    error: error,
	    success: success
	};
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// app.js